import Grid from '@material-ui/core/Grid';
import React, { useMemo } from 'react';
import { useMutation } from 'react-query';
import ItemsDropdownButton from '../../ItemsDropdownButton';
import { useStateObject } from '../../../../hooks/utils';
import AppButtonMain from '../../../basic/AppButtonMain';
import { downloadTraitTemplate } from '../../../../http/download-assets-client';

const TraitReportDemoPreview = (
  {
    trait,
  },
) => {
  const [ context, setContextProperty ] = useStateObject({
    trait,
    category: null,
    locale: null,
    race: null,
  });

  const demoIsDisabled = useMemo(() => {
    return !Object.values(context).every((v) => { return v && v.id; });
  }, [ context ]);

  const {
    mutateAsync: downloadTemplate,
    isLoading: templateIsDownloading,
  } = useMutation(({ trait: { id: traitId }, locale: { id: localeId }, category: { id: categoryId }, race: { id: raceId } }) => {
    return downloadTraitTemplate({
      trait: traitId,
      race: raceId,
      category: categoryId,
      locale: localeId,
    });
  });

  return (
    <>
      <p>{JSON.stringify(context)}</p>
      <ItemsDropdownButton
        title='User race'
        onChange={ (v) => {
          return setContextProperty('race', v);
        } }
        collection='races'
        defaultvalue={ context.race || null }
      />
      <ItemsDropdownButton
        title='User locale'
        onChange={ (v) => { return setContextProperty('locale', v); } }
        collection='locales'
        defaultvalue={ context.locale || null }
      />
      <ItemsDropdownButton
        title='User category'
        onChange={ (v) => { return setContextProperty('category', v); } }
        collection='categories'
        defaultvalue={ context.category || null }
      />
      <Grid item xs={ 12 } style={ { margin: '12px 0px' } }>
        <AppButtonMain
          color='#0bae0e'
          text={ templateIsDownloading ? 'Downloading' : 'Download' }
          disabled={ templateIsDownloading || demoIsDisabled }
          onClick={ () => { return downloadTemplate(context); } }
        />
      </Grid>
    </>
  );
};

export default TraitReportDemoPreview;
